import { PersonOff } from "@mui/icons-material";
import { ChatHelper } from "../helpers";
import { ChatMessage, LiveChatData, ScreenType } from "../types";
import { getInfoMessage } from "../utils/language";

type MessageLiveEndProps = {
    chatHelper?: ChatHelper | null | undefined;
    chatData?: LiveChatData | null | undefined;
    message: ChatMessage;
    screenType?: ScreenType;
};
const MessageLiveEnd: React.FC<MessageLiveEndProps> = ({ chatHelper, chatData, message, screenType }) => {
    if (!chatHelper || !chatHelper.showLiveChatEndBar(message)) {
        return null;
    }

    let icon = null;
    let label = null;
    // if (chatHelper?.getSessionAssign()?.endByRole === UserRole.System) {
    //     icon = (<PowerOff />);
    //     label = getInfoMessage('liveChatEndedDueToConnectionLost', chatData);
    // }else {
    //     icon = (<PersonOff />);
    //     label = getInfoMessage('liveChatEnded', chatData);
    // }
    if (chatHelper?.isSessionEnded()) {
        icon = (<PersonOff />);
        label = getInfoMessage('liveChatEnded', chatData, screenType);
    }
    else {
        return null;
    }

    return (
        <div className="chatyme-message-item chatyme-live-chat-border">
            <span className="chatyme-live-chat-text chatyme-live-chat-end">{icon} {label}</span>
        </div>
    );
};

export default MessageLiveEnd;